import SocialAuthButton from "@components/molecules/social-auth-button";

type Props = {
  type: 'signin' | 'signup';
}

export default function FacebookAuth(props: Props) {
  const { type } = props;

  async function login() {
    const fbState = crypto.randomUUID();
    window.sessionStorage.setItem('fb_s', fbState);

    const appId = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID!;
    const redirectUrl = `${window.location.origin}/auth/facebook`;
    const authUrl = 'https://www.facebook.com/v23.0/dialog/oauth';
    const params = {
      client_id: appId,
      redirect_uri: redirectUrl,
      state: JSON.stringify({
        fb_s: fbState,
        type,
      }),
      response_type: 'token',
      prompt: 'consent',
      scope: [
        'public_profile',
        'email'
      ].join(','),
    };

    const queryString = new URLSearchParams(params).toString();
    window.location.href = `${authUrl}?${queryString}`;
  }

  return (
    <SocialAuthButton.Facebook onClick={login} />
  );
}
